import Select from '@components/fields/Select'
import {phoneCountryCodes} from './codes'

export default function CountryPhone(props) {
  const {countryCode, setCountryCode} = props
  console.log('countryCode inner', countryCode, props)
  return (
    <div className="w-18">
      <Select
        menuWidth={props.width}
        options={phoneCountryCodes}
        value={countryCode}
        isClearable={false}
        filterOption={({data}, inputValue) => {
          // biome-ignore lint/suspicious/noMisleadingCharacterClass: <explanation>
          const input = inputValue.replace(/[\u0300-\u036f]/g, '').toLowerCase()
          const fields = [data.name, data.phoneCode, data.countryCode]
          return fields.some(field => field.normalize('NFD').toLowerCase().includes(input))
        }}
        formatOptionLabel={(country, meta) => {
          if (meta.context === 'menu') {
            return (
              <div className="flex items-center">
                <div
                  style={{backgroundImage: `url(${country.image})`}}
                  className="h-4 w-6 flex-shrink-0 border border-x-[1px] border-y-[1px] border-gray-100 rounded-sm bg-cover bg-center"
                />
                <span className="ml-3 flex-1 truncate">{country.name}</span>
                <span className="ml-3 text-gray-500">({country.phoneCode})</span>
              </div>
            )
          }
          return (
            <div className="flex items-center">
              <div
                style={{backgroundImage: `url(${country.image})`}}
                className="h-4 w-6 flex-shrink-0 border border-x-[1px] border-y-[1px] border-gray-100 rounded-sm bg-cover bg-center"
              />
            </div>
          )
        }}
        onChange={setCountryCode}
      />
    </div>
  )
}
